import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useGetCategory } from "common/hooks/user/Products/useGetCategory";
import { useGetProduct } from "common/hooks/user/Products/useGetProduct";
import { SimpleOrderItem } from "./-components/OrderItem";
import { OutletContextProps } from "./-components/formik-utils";
import { enum_api_uri } from "common/hooks/utils/enum";
import RefreshRedirect from "./-components/RefreshRedirect";
import Header from "user/components/common/Header";
import Progressbar from "./-components/Progressbar";
import Spinner from "common/components/spinner";
import useOverlay, { OverlayWrapper } from "common/hooks/user/useOverlay";
import { cancelMessage, SystemPopup } from "user/components/common/Overlay";
import { ReactComponent as SearchIcon } from "../../assets/icons/searchIcon.svg";
import { ReactComponent as ShppingBag } from "../../assets/icons/shoppingbag.svg";

export default function SelectProduct({ update = false }: { update?: boolean }) {
    const navigate = useNavigate();
    const params = useParams();
    const searchInputRef = useRef<HTMLInputElement | null>(null);
    const context = useOutletContext<OutletContextProps>();
    const formik = context.formik;
    const { values, handleSubmit, setValues, setFieldValue } = formik.product;
    // const { setFieldValue: setToFieldValue, setValues: setToValues, values: toValues } = formik.to;
    const [selectedCategoryIdx, setSelectedCategoryIdx] = useState<number | null>(values.category_idx);
    const [search, setSearch] = useState(false);
    const [searchtxt, setSearchtxt] = useState("");
    const customer_idx = formik.from.values.customer_idx;
    const { data: categoryData } = useGetCategory(customer_idx ?? 0);
    const { data: productData, isPending: isPendingProduct } = useGetProduct(customer_idx ?? 0, selectedCategoryIdx!, searchtxt);
    const { overlay, closeOverlay, openOverlay } = useOverlay();

    // console.log("selectedCategoryIdx", selectedCategoryIdx);
    // console.log("productData", productData);
    // console.log("categoryData", categoryData);

    useEffect(() => {
        if (search && searchInputRef.current) searchInputRef.current?.focus();
    }, [search]);

    const onClickMenu = useCallback((idx: number | null) => {
        setSelectedCategoryIdx(idx);
        setFieldValue("category_idx", idx);
    }, []);

    return (
        <RefreshRedirect customerIdx={customer_idx} isUpdate={update}>
            <OverlayWrapper overlay={overlay} closeOverlay={closeOverlay}>
                <div className="flex-1 flex flex-col">
                    {isPendingProduct && <Spinner />}
                    <div className="sticky top-0 bg-white z-[2]">
                        <Header
                            title="2. 상품 선택"
                            goBack
                            onClickClose={() => openOverlay(<SystemPopup isConfirm message={cancelMessage(update)} onClickClose={closeOverlay} />)}
                        />
                        <Progressbar step={2} className="wrapper" />
                        <div>
                            {search ? (
                                <div className="wrapper flex-1 flex gap-[10px]">
                                    <div className="flex-1 rounded-[8px] bg-[#F3F3F8] py-[8px] px-[12px] flex">
                                        <input
                                            type="text"
                                            value={searchtxt}
                                            ref={searchInputRef}
                                            onChange={e => setSearchtxt(e.target.value)}
                                            placeholder="찾으시는 상품이 있으신가요?"
                                            className="flex-1 bg-transparent placeholder:text-[#999] focus:outline-none"
                                        />
                                        <SearchIcon />
                                    </div>
                                    <button
                                        type="button"
                                        className="text-[#4B632B]"
                                        onClick={() => {
                                            setSearch(false);
                                            setSearchtxt("");
                                        }}
                                    >
                                        닫기
                                    </button>
                                </div>
                            ) : (
                                <div className="wrapper flex border-b border-[#ddd] gap-[10px]">
                                    <ul className="flex-1 flex gap-[16px] overflow-x-auto">
                                        <li
                                            className={`cursor-pointer p-[8px] text-nowrap ${selectedCategoryIdx === null ? "text-black font-bold border-b-[3px] border-black" : "text-[#A3AED0]"}`}
                                            onClick={() => onClickMenu(null)}
                                        >
                                            전체
                                        </li>
                                        {categoryData && categoryData?.length > 0 && (
                                            <React.Fragment>
                                                {categoryData.map((item, index) => {
                                                    return (
                                                        <li
                                                            key={index}
                                                            className={`cursor-pointer p-[8px] text-nowrap text-[#A3AED0] ${selectedCategoryIdx == item.product_category_idx ? "text-black font-bold border-b-[3px] border-black" : "text-[#A3AED0]"}`}
                                                            onClick={() => onClickMenu(item.product_category_idx)}
                                                        >
                                                            {item.category_name}
                                                        </li>
                                                    );
                                                })}
                                            </React.Fragment>
                                        )}
                                    </ul>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setSearch(true);
                                        }}
                                    >
                                        <SearchIcon />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="wrapper bg-white py-[16px] flex-1 flex flex-col gap-[16px]">
                        {productData?.map(item => {
                            return (
                                <div key={item.product_idx} className="flex items-center justify-between cursor-pointer gap-[20px]">
                                    {/* 상품 디테일 보기 */}
                                    <div
                                        className="flex-1 max-w-[80%]"
                                        onClick={() => {
                                            update
                                                ? navigate(`/orders/${params.idx}/update/product-detail/${item.product_idx}`)
                                                : navigate(`/new-order/product-detail/${item.product_idx}`);
                                        }}
                                    >
                                        <SimpleOrderItem
                                            size="large"
                                            category={item.product_category.category_name}
                                            name={item.product_name}
                                            // name='본인결혼,★전문기술원'
                                            className="mobile450:gap-2"
                                            price={item.product_amount}
                                            img={`${item.product_image ? `${enum_api_uri.api_uri}/${item.product_image.file_name}` : ""}`}
                                        />
                                    </div>
                                    <button
                                        type="button"
                                        className="bg-[#4B632B] w-[40px] h-[40px] rounded-[12px] flex items-center justify-center shrink-0"
                                        onClick={() => {
                                            setValues({
                                                ...values,
                                                product_idx: item.product_idx,
                                                union_option: item.product_category.union_option,
                                            });
                                            handleSubmit();
                                        }}
                                    >
                                        <ShppingBag />
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </OverlayWrapper>
        </RefreshRedirect>
    );
}
